module.exports = __webpack_public_path__ + "static/media/candle-holder.bf7e35a7.svg";